export const fontFamily = [
  "Roboto",
  "Noto Sans",
  "Noto Sans TC",
  "Noto Sans SC",
  "sans-serif",
].join(",");

export default fontFamily;
